import { FC, useState } from 'react';
import { KioskTypes } from '../../../../../types';
import ContentContainer from '../../../../layout/content-container.component';
import Header from '../../../../layout/header.component';
import { ExistingPatronForm } from '../../../components/existing-patron-form';
import { NewPatronForm } from '../../../components/new-patron-form';
import { FillingExperienceProps } from '../../../filling-experience.type';
import { FillingExperienceWrapper } from '../../../provider';

type KioskFormFillingExperienceProps = FillingExperienceProps & {
  patronType: KioskTypes.Patron;
};

export const KioskForm: FC<KioskFormFillingExperienceProps> = (props) => {
  // Country selector is only relevant once the patron form is shown, not on the welcome screen
  const [showCountrySelector, setShowCountrySelector] = useState(false);

  return (
    <FillingExperienceWrapper {...props} experienceType='kiosk' documentType='form'>
      <Header showCountrySelector={showCountrySelector} />
      <ContentContainer>
        {props.patronType === 'existing' ? (
          <ExistingPatronForm onWelcomeAccept={() => setShowCountrySelector(true)} />
        ) : (
          <NewPatronForm onWelcomeAccept={() => setShowCountrySelector(true)} />
        )}
      </ContentContainer>
    </FillingExperienceWrapper>
  );
};
